import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
// TODO: 16px svg source needs to remove rotation
const draw24px = 'M15.87,12.46s0,.1,0,.15a.75.75,0,0,1-.21.38L12.1,16.54a.77.77,0,0,1-.53.22.79.79,0,0,1-.53-.22.75.75,0,0,1,0-1.06l2.27-2.27H11.38c-5.14,0-8.33-3.36-8.33-8.75a.75.75,0,0,1,1.5,0c0,4.6,2.49,7.25,6.83,7.25h1.93L11,9.43A.75.75,0,0,1,12.1,8.37l3.55,3.56a.74.74,0,0,1,.17.25A.82.82,0,0,1,15.87,12.46Zm0,0h0s0,.1,0,.15A.92.92,0,0,0,15.87,12.45Zm0-.27a.72.72,0,0,1,0,.27A.62.62,0,0,0,15.82,12.18Zm4,3.93V8a3.76,3.76,0,0,0-3.75-3.75H8.86a.75.75,0,0,0,0,1.5h7.2A2.25,2.25,0,0,1,18.31,8v8.13a2.25,2.25,0,0,1-2.25,2.25H7.94a2.25,2.25,0,0,1-2.25-2.25V15a.75.75,0,0,0-1.5,0v1.28a.37.37,0,0,0,0,.11,3.75,3.75,0,0,0,3.74,3.5h8.12A3.75,3.75,0,0,0,19.81,16.11Z';
const icons = {
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const ImportIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'import'));
ImportIcon.displayName = 'ImportIcon';
ImportIcon.propTypes = Icon.propTypes;
ImportIcon.renderIcon = props => /*#__PURE__*/React.createElement(ImportIcon, props);
export default ImportIcon;
//# sourceMappingURL=ImportIcon.js.map